<template>
	<!-- 执行标准 -->
	<div class="container_page">
		<a-table style="width: 50%;" :columns="columns" :data-source="tableData" @change="changePage"
			:loading="loading">
			<template slot="render" slot-scope="text, record">
				<a-input v-model="record.configValue" placeholder="请输入"></a-input>
			</template>

		</a-table>
		<div style="display: flex;align-items: center;">
			<div v-if="lastFeedbackItem.configValue">
				<viewer :images="[lastFeedbackItem.configValue]">
					<div class="er_content">
						<img class="er_content_img" :src="img" v-for="(img,index) in [lastFeedbackItem.configValue]"
							:key="index">
					</div>
				</viewer>
			</div>
			<div class="again_upload_box ml12">
				<a-spin v-if="uploadLoading" />
				<template v-else>
					<input type="file" accept="image/*" @change="handleUploadThumbnail" />
					<i class="el-icon-box again_upload_icon"></i>
					<div class="bold" style="width: 100px">
						{{ img ? "重新上传" : "上传" }}
					</div>
				</template>
			</div>
		</div>

		<a-button @click="save" type="primary">保存</a-button>

	</div>
</template>

<script>
	import {
		ossUpload
	} from "../../utils/oss";
	import {
		getHotlineServiceApi, //  执行标准列表
		editHotlineServiceApi, //  执行标准新增/编辑
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {
				columns: [{
						title: '名称',
						dataIndex: 'name',
						key: 'name',
					},
					{
						title: '板块',
						dataIndex: 'section',
						key: 'section',
					},
					{
						title: '热线',
						dataIndex: 'configValue',
						key: 'configValue',
						scopedSlots: {
							customRender: "render"
						},
					}
				],
				tableData: [],
				loading: false,
				editModel: {
					flag: false,
					title: "",
					executionStandardId: '',
					onOk: () => {},
				},
				uploadLoading: false,
				img: "",
				filterData: {
					keywords: "",
					standardCode: "",
					implementationStatus: undefined,
					lang: "CH",
					tagId: ''
				},
				lastFeedbackItem: {
					configId: null,
					configValue: ""
				}
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('hotlineQrcode_searchQuery');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
			} else {}
			this.getData(1)
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('hotlineQrcode_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			changePage() {
				// this.pageInfo.current = page.current;
				// this.getData(this.pageInfo.current);
			},
			getData() {
				if (this.loading) {
					return;
				}
				this.loading = true;
				getHotlineServiceApi({})
					.then((res) => {
						if (res.resultStatus) {
							const allList = res.resultData.dataList || [];
							// 定义变量接收最后一条数据，页面可单独渲染
							this.lastFeedbackItem = null;
							if (allList.length > 0) {
								// 取出最后一条，原数组会删除末尾元素
								this.lastFeedbackItem = allList.pop();
							}
							// 表格只展示除去最后一条的剩余数据
							this.tableData = allList;
							// 总数用原始总条数，不改变分页统计
							// this.pageInfo.total = res.resultData.totalNum || 0;
						} else {
							this.tableData = [];
							this.lastFeedbackItem = null;
							// this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			// 转换原始数组 => 后端接收参数数组
			formatSubmitConfig() {
				return this.tableData.map(item => {
					// 二维码特殊兜底：空值替换默认图
					let val = item.configValue
					return {
						configId: item.configId,
						configValue: item.configValue?.trim() || ''
					}
				})
			},
			save() {
				// const params = this.formatSubmitConfig()
				// params.push({
				// 	confirmId:this.lastFeedbackItem.configId,
				// 	configValue:this.lastFeedbackItem.configValue
				// })


				// 1. 校验两条必填热线
				const requireList = this.tableData.filter(item => item.isRequired === true)
				let emptyName = ''
				for (let item of requireList) {
					if (!item.configValue || item.configValue.trim() === '') {
						emptyName = item.name
						break
					}
				}
				if (emptyName) {
					this.$message.warning(`${emptyName}不能为空，请填写热线号码`)
					return
				}

				// 2. 组装表格热线数据
				const params = this.formatSubmitConfig()
				// 3. 组装二维码条目，字段改为configId（原confirmId写错）
				if (this.lastFeedbackItem?.configId) {
					let qrVal = this.lastFeedbackItem.configValue
					// 二维码空值兜底默认图
					// if (!qrVal) qrVal = '/uploads/qrcode/assistant_default.png'
					params.push({
						configId: this.lastFeedbackItem.configId,
						configValue: qrVal
					})
				}

				editHotlineServiceApi(params)
					.then((res) => {
						if (res.resultStatus) {
							this.$message.success(
								"保存成功"
							);
						} else {
						}
					})
					.catch((error) => {
					})
					.finally(() => {
						this.getData()
					})
			},
			// 上传文件
			handleUploadThumbnail(e) {
				if (e.target.files.length) {
					const file = e.target.files[0];
					if (file) {
						this.uploadLoading = true;
						ossUpload(file, '', 'image/').then((res) => {
							this.lastFeedbackItem.configValue = res.url;
						}).catch(err => {
							this.$message.error('图片上传失败')
						}).finally(() => {
							this.uploadLoading = false;
						});
					}
				}
			},
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}

	.size_item {
		height: 50px;
		/* 改为固定高度，不要 min-height */
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		/* 间距改小，更美观 */
		cursor: move;
		padding: 0 10px;

		.left {
			flex: 1;
			padding-left: 10px;
		}

		.right {
			width: 50px;
			text-align: center;
		}
	}

	.lang-radio-wrap {
		display: flex;
		justify-content: center;
		margin-bottom: 16px;
	}
</style>